import { render, staticRenderFns } from "./IconSetCover.vue?vue&type=template&id=578bc275&scoped=true&"
import script from "./IconSetCover.vue?vue&type=script&lang=js&"
export * from "./IconSetCover.vue?vue&type=script&lang=js&"
import style0 from "./IconSetCover.vue?vue&type=style&index=0&id=578bc275&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578bc275",
  null
  
)

export default component.exports